
import React, { Component } from 'react';
import { Modal, Form, Input, Col, Row, Divider, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';

const fields = [{
    "text": "合同编号",
    "field": "contractNo",
    "disabled": true,
}, {
    "text": "厂牌型号",
    "field": "brandModel",
    "disabled": true,
}, {
    "text": "车架号",
    "field": "vin",
    "disabled": true,
}, {
    "text": "车牌号",
    "field": "plateNo",
    "disabled": true,
}, {
    "text": "发动机号",
    "field": "engineNo",
    "disabled": true,
}, {
    "text": "初登日期",
    "field": "registerDate",
    "disabled": true,
}, {
    "text": "使用性质",
    "field": "useProperty",
    "disabled": true,
}, {
    "text": "提供的证件",
    "field": "certificate",
    "disabled": true,
}, {
    "text": "交强险有效期",
    "field": "mandatoryInsuranceDate",
    "disabled": true,
}, {
    "text": "商业险有效期",
    "field": "commerciaInsuranceDate",
    "disabled": true,
}, {
    "text": "钥匙数量",
    "field": "keyNum",
    "disabled": true,
}, {
    "text": "约定完成时间/天",
    "field": "timeLimit",
    "number": true,
    rules: [
        { required: true, message: '约定完成时间不能为空!' },
    ]
}, {
    "text": "车辆转让价",
    "field": "finalPrice",
    "disabled": true,
}, {
    "text": "订金",
    "field": "deposit",
    "number": true,
    rules: [
        { required: true, message: '订金不能为空!' },
    ]
}, {
    "text": "车辆类型",
    "field": "carType"
}, {
    "text": "车辆颜色",
    "field": "carColor"
}, {
    "text": "表征里程",
    "field": "carMileage",
    "addonAfter": "公里"
}, {
    "text": "签约地点",
    "field": "signAddr",
    rules: [
        { required: true, message: '签约地点不能为空!' },
        { max: 64, message: '签约地点不能超过64个字符！' },
    ]
}, {
    "text": "取车地点",
    "field": "pickUpAddr",
    rules: [
        { required: true, message: '取车地点不能为空!' },
        { max: 64, message: '取车地点不能超过64个字符！' },
    ]
}, {
    "text": "卖方名称",
    "field": "sellerName",
    "diabled": true,
    // rules: [
    //     { required: true, message: '卖方名称不能为空!' },
    //     { max: 32, message: '卖方名称不能超过32个字符！' },
    // ]
}, {
    "text": "卖方证件号",
    "field": "sellerCreditNo",
    rules: [
        { required: false, message: '卖方证件号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "卖方电话",
    "field": "sellerTel",
    rules: [
        { required: false, message: '卖方电话不能为空!' },
        validator.tel
    ]
}, {
    "text": "卖方收款银行",
    "field": "sellerBank",
    rules: [
        { max: 16, message: '卖方收款银行不能超过16个字符！' },
    ]
}, {
    "text": "卖方银行户名",
    "field": "sellerBankAccountName",
    rules: [
        { max: 64, message: '卖方银行户名不能超过64个字符！' },
    ]
}, {
    "text": "卖方银行账号",
    "field": "sellerBankAccountNo",
    rules: [
        { max: 64, message: '卖方银行账号不能超过64个字符！' },
        validator.enNum
    ]
}, {
    "text": "卖方地址",
    "field": "sellerAddr",
    "span": 2,
    rules: [
        { required: false, message: '卖方地址不能为空!' },
        { max: 64, message: '卖方地址不能超过64个字符！' },
    ]
}, {
    "text": "买方名称",
    "field": "buyerName",
    "diabled": true,
    // rules: [
    //     { required: true, message: '买方名称不能为空!' },
    //     { max: 32, message: '买方名称不能超过32个字符！' },
    // ]
}, {
    "text": "买方证件号",
    "field": "buyerCreditNo",
    rules: [
        { required: false, message: '买方证件号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "买方电话",
    "field": "buyerTel",
    rules: [
        { required: false, message: '买方电话不能为空!' },
        validator.tel
    ]
}, {
    "text": "买方收款银行",
    "field": "buyerBank",
    rules: [
        { max: 16, message: '买方收款银行不能超过16个字符！' },
    ]
}, {
    "text": "买方银行户名",
    "field": "buyerBankAccountName",
    rules: [
        { max: 64, message: '买方银行户名不能超过64个字符！' },
    ]
}, {
    "text": "买方银行账号",
    "field": "buyerBankAccountNo",
    rules: [
        { max: 64, message: '买方银行账号不能超过64个字符！' },
        validator.enNum
    ]
}, {
    "text": "买方地址",
    "field": "buyerAddr",
    "span": 2,
    rules: [
        { required: false, message: '买方地址不能为空!' },
        { max: 64, message: '买方地址不能超过64个字符！' },
    ]
}, {
    "text": "其他事项",
    "field": "otherMatters",
    "span": 2,
    "textarea": true,
    rules: [
        { max: 512, message: '其他事项不能超过512个字符！' },
    ]
}];


class AuctionContractEditForm extends Component {

    state = {
        //其他额外照片
        visible: false, // 扫描仪
        otherImagesUrl: [],
        otherImage: [],
    }

    componentDidMount() {
        this.props.initEdit(this.initEdit);
    }

    initEdit = (data) => {
        let otherImages = data.contractImage;
        let otherImagesUrl = [];
        let otherImage = [];
        if (otherImages != null && otherImages.length > 0) {
            for (let index in otherImages) {
                if (otherImages[index] != null && otherImages[index] !== "") {
                    otherImage.push("data:image/jpeg;base64," + otherImages[index].replace(/\r\n/g, ""));
                }
            }
            otherImagesUrl = data.contractImageUrl;
        }
        this.setState({ otherImage: otherImage, otherImagesUrl: otherImagesUrl });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            let other = [];
            let otherImage = this.state.otherImage;
            let otherImagesUrl = this.state.otherImagesUrl;
            for (let i = 0; i < this.state.otherImage.length; i++) {
                if (otherImagesUrl.length > i && otherImagesUrl[i] != null && otherImagesUrl[i] !== "") {
                    other.push(otherImagesUrl[i]);
                } else {
                    other.push(otherImage[i]);
                }
            }
            values["contractImage"] = JSON.stringify(other);

            http.post({
                url: '/auctionResult/saveLotsContractInfo',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    create2Col = (fields) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let result = [];
        let odd = false;
        for (let i = 0; i < fields.length; i++) {
            let span = 11;
            let offset = odd ? 2 : 0;
            let item = fields[i];
            let labelCol = { span: 9 };
            let wrapperCol = { span: 15 };
            if (fields[i].span != null && fields[i].span === 2) {
                span = 24;
                offset = 0;
                odd = true;
                labelCol = { span: 4 };
                wrapperCol = { span: 20 };
            }
            let itemDom = (<Col key={i} span={span} offset={offset}>
                <Form.Item key={i} label={item.text + "："} labelCol={labelCol} wrapperCol={wrapperCol}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.number ? <InputNumber precision={0} min={0} style={{ width: '100%' }} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input disabled={item.disabled === true} addonAfter={item.addonAfter?item.addonAfter:''} />
                        )
                    }
                </Form.Item>
            </Col>);
            odd = !odd;
            result.push(itemDom);
        }
        return result;
    }

    createOtherImageDom = () => {
        let dom = [];
        let data = this.state.otherImage;
        let otherImagesUrl = this.state.otherImagesUrl;
        for (let i = 0; i <= data.length && i < 6; i++) {
            let file = data[i];
            let url = i < otherImagesUrl.length ? otherImagesUrl[i] : null;
            dom.push(
                <Col span={4} key={i} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, "otherImage")}
                        onChange={this.handleUploadImage.bind(this, "otherImage")}
                        onRemove={this.handleRemoveImage.bind(this, "otherImage", i)}
                        file={file}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }

    handleUploadImage = (field, { base64 }) => {
        const list = this.state.otherImage;
        list.push(base64);
        this.setState({ "otherImage": list });
    }
    handleRemoveImage = (field, index) => {
        if (field === "otherImage") {
            const list = this.state.otherImage;
            const otherImagesUrl = this.state.otherImagesUrl;
            list.splice(index, 1);
            otherImagesUrl.splice(index, 1);
            this.setState({ "otherImage": list, "otherImagesUrl": otherImagesUrl });
        }
    }
    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={840}
                visible={visible}
                title="竞价交易合同信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical">
                    {this.create2Col(fields)}
                    <Divider orientation="left">合同照片</Divider>
                    <Row>{this.createOtherImageDom()}</Row>
                </Form>
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                    // successCallback={}
                />
            </Modal>
        );
    }
}

const AuctionContractEdit = Form.create()(AuctionContractEditForm);

export default AuctionContractEdit;
